import IconConstants from '@/lib/iconConstants';
import AppConstants from '@/lib/appConstants';
import { Vue } from 'vue-property-decorator';
import EntityType from '@/models/Shared/EntityType';
import ComponentLocation from '@/models/Shared/ComponentLocation';
import WorkerPositionStatus from '@/models/WorkerPositions/WorkerPositionStatus';
import WorkerSkillStatus from '@/models/WorkerSkills/WorkerSkillStatus';
import WorkerQualificationStatus from '@/models/WorkerQualifications/WorkerQualificationStatus';
import BookingStatus from '@/models/Bookings/BookingStatus';
import { AppModule } from '@/store/modules/app';
import AgencyLabelDto from '@/models/Agencies/AgencyLabels';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';
import { Permissions, PermissionCode, canView, canManage, hasPermission, PERMISSION_VIEW, PERMISSION_MANAGE, PERMISSION_NONE } from '@/lib/permissions';

export default class GiganautVue extends Vue {
  public IconConstants = IconConstants;
  public AppConstants = AppConstants;
  public EntityType = EntityType;
  public ComponentLocation = ComponentLocation;
  public StatusDisplayLocation = StatusDisplayLocation;
  public WorkerPositionStatus = WorkerPositionStatus;
  public WorkerSkillStatus = WorkerSkillStatus;
  public WorkerQualificationStatus = WorkerQualificationStatus;
  public BookingStatus = BookingStatus;

  // Permission constants exposed to templates.
  // Use like: v-if="canManage(Permissions.Workers)"
  public Permissions = Permissions;
  public PERMISSION_NONE = PERMISSION_NONE;
  public PERMISSION_VIEW = PERMISSION_VIEW;
  public PERMISSION_MANAGE = PERMISSION_MANAGE;

  /** Returns true if the current user can view the given area. */
  public canView(code: PermissionCode): boolean {
    return canView(code);
  }

  /** Returns true if the current user can manage (create/edit/delete) the given area. */
  public canManage(code: PermissionCode): boolean {
    return canManage(code);
  }

  /** Returns true if the current user has at least `minLevel` on the given area. */
  public hasPermission(code: PermissionCode, minLevel: number): boolean {
    return hasPermission(code, minLevel);
  }


  public get Labels() {
    if (AppModule.currentAgencyContext === null) {
      return new AgencyLabelDto();
    }
    return AppModule.currentAgencyContext.labels;
  }
}
